// Calendar-date helpers on ISO 'YYYY-MM-DD' strings. All arithmetic is done in UTC so a
// date never shifts by a day because of the server's time zone.

export type IsoDate = string;

export function parseIso(d: IsoDate): Date {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(d)) throw new Error(`bad date: ${d}`);
  return new Date(`${d}T00:00:00Z`);
}

export function toIso(d: Date): IsoDate {
  return d.toISOString().slice(0, 10);
}

export function addDays(d: IsoDate, days: number): IsoDate {
  const x = parseIso(d);
  x.setUTCDate(x.getUTCDate() + days);
  return toIso(x);
}

export function daysBetween(from: IsoDate, to: IsoDate): number {
  return Math.round((parseIso(to).getTime() - parseIso(from).getTime()) / 86_400_000);
}

export function firstOfMonth(d: IsoDate): IsoDate {
  return `${d.slice(0, 7)}-01`;
}

export function addMonths(monthStart: IsoDate, n: number): IsoDate {
  const x = parseIso(firstOfMonth(monthStart));
  x.setUTCMonth(x.getUTCMonth() + n);
  return toIso(x);
}

export function lastOfMonth(d: IsoDate): IsoDate {
  return addDays(addMonths(firstOfMonth(d), 1), -1);
}

export function daysInMonth(d: IsoDate): number {
  return Number(lastOfMonth(d).slice(8, 10));
}

/** Today's date in a given IANA time zone (stores run on local business days). */
export function todayIn(timeZone = 'America/New_York', now = new Date()): IsoDate {
  const parts = new Intl.DateTimeFormat('en-CA', { timeZone, year: 'numeric', month: '2-digit', day: '2-digit' }).format(now);
  return parts; // en-CA formats as YYYY-MM-DD
}
